import { Modal } from "@mui/material";
import styled from "styled-components";
import IconFail from "../../assets/images/icon-fail.svg"

const Container = styled.div`
    width: calc(480px - 72px);
    padding: 36px;
    border-radius: 16px;
    background-color: #FFFFFF;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 30px 0px #00266F29;
    display: flex;
    flex-direction: column;

    &:focus-visible {
        outline: none;
    }

    .image {
        margin-bottom: 24px;
    }
    
    .label {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: center;
    }
`;

function TokenExpireModal({
    open,
}) {
    return (
        <Modal
            className="content-center"
            open={open || false}
        >
            <Container>
                <div className="image content-center">
                    <img alt="img" src={IconFail} />
                </div>
                <div className="label content-center">Session หมดอายุ</div>
            </Container>
        </Modal>
    )
}

export default TokenExpireModal;